import React from 'react';
import {FormattedMessage} from "react-intl";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    List,
    ListItemButton,
    ListItemText,
    Stack,
} from "@mui/material";
import {DepartmentDto} from "../../../../../modules/account/dto/DepartmentDto";
import CloseButton from "../../../../../components/buttons/CloseButton";

export type DepartmentSelectDialogProps = {
    open: boolean;
    departments: Array<DepartmentDto>;
    onSelect: (value: string) => void;
    onClose: () => void;
};

const DepartmentSelectDialog: React.FC<DepartmentSelectDialogProps> = (props) => {

    const _handleCancel = () => {
        props.onClose();
    };

    const _handleSelect = (item: DepartmentDto) => {
        props.onSelect(item.id);
        props.onClose();
    }

    const _renderChildren = (children: Array<DepartmentDto>, level: number) => {
        return (
            <List component="div" disablePadding>
                {
                    children.map((child, index) => {
                        return (
                            <div>
                                <ListItemButton key={child.id} sx={{pl: 4 * level}} onClick={() => _handleSelect(child)}>
                                    <ListItemText primary={child.name} secondary={child.code}/>
                                </ListItemButton>
                                {child.children ? _renderChildren(child.children, level + 1) : null}
                            </div>
                        )
                    })
                }
            </List>
        )
    }

    return (
        <Dialog open={props.open} onClose={_handleCancel} fullWidth={true}>
            <DialogTitle>
                <Stack direction={'row'} justifyContent={'space-between'}>
                    <FormattedMessage id={'ACCOUNT_DEPARTMENT_SELECT'}/>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <List>
                    {
                        props.departments.map((item, index) => {
                            return (
                                <div key={item.id}>
                                    <ListItemButton onClick={() => _handleSelect(item)}>
                                        <ListItemText primary={item.name} secondary={item.code}/>
                                    </ListItemButton>
                                    {item.children ? _renderChildren(item.children, 1) : null}
                                    <Divider sx={{mt: 2, mb: 2}}/>
                                </div>
                            )
                        })
                    }
                </List>
            </DialogContent>
            <DialogActions>
                <CloseButton onClick={_handleCancel}/>
            </DialogActions>
        </Dialog>
    );
};

export default DepartmentSelectDialog;
